__turbopack_context__.v({
  "buttons": "DeliveryModal-module-scss-module__J_h3bW__buttons",
  "deliveryModal": "DeliveryModal-module-scss-module__J_h3bW__deliveryModal",
  "delivery__title": "DeliveryModal-module-scss-module__J_h3bW__delivery__title",
  "delivery__title2": "DeliveryModal-module-scss-module__J_h3bW__delivery__title2",
  "list": "DeliveryModal-module-scss-module__J_h3bW__list",
});
